import { Injectable } from "@angular/core";

import { environment } from "@environment";

export enum EventCategory {
  C = "CLIENT",
  S = "SESSION",
  A = "API",
}

@Injectable({ providedIn: "root" })
export class AnalyticsService {
  public init(): void {
    if (!environment.gtagId) {
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gtagId}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function (): void {
      window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", environment.gtagId);
  }

  public client(name: string): void {
    this.track(`${name}_clicked`, EventCategory.C);
  }

  public api(name: string): void {
    this.track(name, EventCategory.A);
  }

  public track(name: string, category: EventCategory): void {
    if (!window.gtag) {
      return;
    }

    const event = name.toLowerCase().replace(/[-_ ]/g, "_");
    try {
      window.gtag("event", event, { event_category: category, event_label: event });
    } catch (err) {
      console.warn("Gtag error", err);
    }
  }
}
